<icds-drawer
	[dataContextTitle]="'domain-model.evaluation.property.restrictiveMeasures.label' | translate"
	(closedWithoutRequest)="closeActionOverlay('aside')"
>
	<icds-query-state [dataQuery]="restrictiveMeasuresForResidentQuery">
		<ng-template let-restrictiveMeasuresForResidentData [icdsQueryDataFrom]="restrictiveMeasuresForResidentQuery">
			@let restrictiveMeasures = restrictiveMeasuresForResidentData.data;

			<ng-template icdsOverlayHeaderTemplate>
				<icds-page-section-heading>
					@if (resident(); as resident) {
						{{ resident.fullName }}
					}
				</icds-page-section-heading>
			</ng-template>
			<icds-page-subsection [dataTitle]="'domain-model.resident.property.evaluationMeasuresActive.label' | translate">
				@let activeMeasures = restrictiveMeasures.ACTIVE ?? [];
				<ng-container slot="headerActions">
					@if (activeMeasures.length > 0) {
						<icds-simple-button
							dataIcon="DOWNLOAD"
							[dataLabel]="'features/observations.actions.downloadDocument' | translate"
							(buttonClick)="onDownloadReport(activeMeasures, 'ACTIVE')"
						/>
					}
				</ng-container>
				<ic-restrictive-measure-list
					[dataCareTreeValueSet]="careTreeValueSetQuery.data()"
					[dataRestrictiveMeasures]="activeMeasures"
				/>
			</icds-page-subsection>
			<icds-page-subsection-divider />
			<icds-page-subsection [dataTitle]="'domain-model.resident.property.evaluationMeasuresStopped.label' | translate">
				@let stoppedMeasures = restrictiveMeasures.STOPPED ?? [];
				<ng-container slot="headerActions">
					@if (stoppedMeasures.length > 0) {
						<icds-simple-button
							dataIcon="DOWNLOAD"
							[dataLabel]="'features/observations.actions.downloadDocument' | translate"
							(buttonClick)="onDownloadReport(stoppedMeasures, 'STOPPED')"
						/>
					}
				</ng-container>
				<ic-restrictive-measure-list
					[dataCareTreeValueSet]="careTreeValueSetQuery.data()"
					[dataRestrictiveMeasures]="stoppedMeasures"
				/>
			</icds-page-subsection>
		</ng-template>
		<ng-template icdsQueryDataLoading>
			<ng-template icdsOverlayHeaderTemplate>
				<icds-page-subsection-heading-skeleton />
			</ng-template>
			<ic-restrictive-measures-overlay-skeleton />
		</ng-template>
	</icds-query-state>
</icds-drawer>
